import { render, staticRenderFns } from "./test-table.vue?vue&type=template&id=d650b55e&scoped=true&"
import script from "./test-table.vue?vue&type=script&lang=js&"
export * from "./test-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d650b55e",
  null
  
)

export default component.exports